// extracted by mini-css-extract-plugin
export default {"flex":"_2VlyM8rhTPfnbjJG6JON_T"};